





















import { Component, Vue } from 'vue-property-decorator'
import { FillInfoItemOfForm, OperationItemType, OptionItemType } from '../../types/type'
import { getAllFatherNodeForTree, findItemForTree, disposeFillInfoToParamsForCM } from '../../utils/toolsForCommon'
import { CommonModule, UserModule } from '../../store'
@Component({
  name: 'AddOrUpdateRetainSpecimen',
  components: {
    'form-module': () => import('../../components/common/formModule.vue')
  }
})
export default class AddOrUpdateRetainSpecimen extends Vue {
  public loading = false
  public headerOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]
  public bottomOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: `保存`,
      key: 'save',
      type: 'success',
      size: ''
    }
  ]
  // 枚举选项：
  public optionsForMeal: Array<OptionItemType> = [
    {
      name: '早餐',
      value: 1
    },
    {
      name: '中餐',
      value: 2
    },
    {
      name: '晚餐',
      value: 3
    }
  ]
  public fillInfoList: Array<FillInfoItemOfForm> = [
    {
      title: '乡镇',
      type: 'text',
      key: 'villagesAndTownsForAddOrUpdateRetainSpecimen',
      value: '',
      placeholder: '请输入乡镇',
      isNecessary: true,
      disabled: true,
      temporaryStorageForValue: null,
      explainText: '说明：无需输入，选择学校可自动匹配乡镇'
    },
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationNameForAddOrUpdateRetainSpecimen',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '留样日期',
      type: 'dateForDate',
      key: 'time',
      value: '',
      placeholder: '请留样日期',
      isNecessary: true
    },
    {
      title: '餐别',
      type: 'select',
      key: 'meal',
      value: '',
      placeholder: '请选择餐别',
      selectOptions: [],
      isNecessary: true
    },
    {
      title: '留样菜名',
      type: 'text',
      key: 'dishName',
      value: '',
      placeholder: '请输入留样菜名',
      isNecessary: true
    },
    {
      title: '留样人姓名',
      type: 'text',
      key: 'recordor',
      value: '',
      placeholder: '请输入留样人姓名',
      isNecessary: true
    },
    {
      title: '留样图片',
      type: 'photoForList',
      key: 'picture',
      value: '',
      placeholder: '请上传留样图片',
      isNecessary: true,
      imgList: [],
      explainText: '说明：可上传多张图片'
    },
    {
      title: '备注',
      type: 'textarea',
      key: 'comment',
      value: '',
      placeholder: '请输入备注',
      isNecessary: false
    }
  ]

  // 新增编辑的文字展示
  get addOrUpdateTitle (): string {
    const { id } = this.$route.query
    let res: string = '新增'
    if (id && id !== 'add') {
      res = '编辑'
    }
    return `${res}`
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  async created () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.disposeForFillInfoList()
    let { id } = (this as any).$route.query
    if (!id) return (this as any).$router.go(-1)
  }

  // 选择框数据处理
  disposeForFillInfoList () {
    this.fillInfoList = this.fillInfoList.map(item => {
      switch (item.key) {
        case 'villagesAndTownsForAddOrUpdateRetainSpecimen':
          const chooseItemForAllFather = getAllFatherNodeForTree(this.treeDataForOrganatizion, 'children', 'id', this.userInfo.organizationId)
          // 拿到乡镇的id:
          let idForTown = chooseItemForAllFather[chooseItemForAllFather.length - 2]
          if (idForTown) {
            const resForTown = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', idForTown)
            if (resForTown) {
              item.value = (resForTown as any).name
              item.temporaryStorageForValue = resForTown
            }
          }
          break
        case 'organizationNameForAddOrUpdateRetainSpecimen':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          item.temporaryStorageForValue = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
        case 'meal':
          item.selectOptions = this.optionsForMeal
          break
      }
      return item
    })
  }

  async saveAll (continuousValue) {
    try {
      let whoEmpty = null
      let isEmpty = this.fillInfoList.some(item => {
        if (item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      const params = disposeFillInfoToParamsForCM(this.fillInfoList)
      let { id } = this.$route.query
      if (id && id !== 'add') {
        Object.assign(params, { id })
      }
      const { data: result } = await (this as any).$http.dailyRcordDishesSave(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(`${this.addOrUpdateTitle}成功`)
      setTimeout(() => {
        if (continuousValue) {
          this.$router.replace({ name: 'AddOrUpdateRetainSpecimen', query: { id: 'add' } })
          window.location.reload()
        } else {
          this.$router.push({ name: 'RetainSpecimen' })
        }
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  getFormResultFromChild (result) {
    let { key, value } = result
    this.fillInfoList = this.fillInfoList.map(item => {
      if (item.key === key) {
        switch (key) {
          case 'villagesAndTownsForAddOrUpdateRetainSpecimen':
            item.temporaryStorageForValue = value
            item.value = value.name ? value.name : '- -'
            break
          // 学校：
          case 'organizationNameForAddOrUpdateRetainSpecimen':
            item.temporaryStorageForValue = value
            break
          case 'picture':
            item.imgList.push({
              url: value
            })
            item.value = item.imgList.map(item => item.url).join(',')
            break
          default:
            item.value = value
            break
        }
      }
      return item
    })
  }

  // 拿到多张图片：
  getFormResultForHandleRemoveForPhotoForList (result): void {
    let { key, value } = result
    this.fillInfoList = this.fillInfoList.map(item => {
      if (item.key === key) {
        switch (key) {
          case 'picture':
            item.imgList = value.map(item => {
              return {
                url: item.url
              }
            })
            item.value = item.imgList.map(item => item.url).join(',')
            break
        }
      }
      return item
    })
  }

  operationForButton ({ key }) {
    switch (key) {
      case 'back':
        this.$router.go(-1)
        break
      case 'save':
        this.saveAll((this as any).$refs.refOfFormModule.continuousValue)
        break
    }
  }
}
